import { LOCAL_STORAGE_KEYS } from "@/src/config/constant";
import { persistSaveGoalDraftId } from "@/src/hooks/onboarding/saveGoalDraftIdStorage";

/**
 * Plan Goal Chat 路由与 GOAL_ID 约定见：
 * `features/20260611-plan-checkup-dimensions/SPEC.md` §5–§6
 * （四条入口真值：`PlanGoalChatDemoPanel` + `usePlanGoalChatOpen`）
 */

/** 进入 onboarding 前：清空续聊 chat_id */
export const preparePlanGuideOnboardingEntry = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(LOCAL_STORAGE_KEYS.CHAT_ID);
};

/**
 * Plan 有草稿续建：写入 LOCAL_STORAGE_KEYS.GOAL_ID（confirm-save 优先读取，不回传 Agent）。
 */
export const persistPlanDraftGoalIdToStorage = (draftGoalId: string): void => {
  persistSaveGoalDraftId(draftGoalId);
};
